module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper"
  }, [_c('second-header'), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "main-inner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('search-bar'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "background-white mb80",
    staticStyle: {
      "margin-top": "0.3em !important",
      "border": "#edf7f6 solid"
    }
  }, [_c('div', {}, [_c('img', {
    staticClass: "wn-bbanner mobi-off",
    staticStyle: {
      "height": "350px !important"
    },
    attrs: {
      "src": "/static/assets/img/home-banner-parkwell-insuremoto.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "detail-banner-left"
  }, [_c('h4', {
    staticClass: "detail-title",
    staticStyle: {
      "float": "left"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.cninsurance_listing.cninsurance_name))]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v(_vm._s(_vm.cninsurance_listing.cninsurance_tagline))])]), _vm._v(" "), _c('div', {
    staticClass: "wn-xmenu"
  }, [_c('button', {
    staticClass: "btn wn-menu-btn btn-xm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewComponent('set_get_insurance')
      }
    }
  }, [_vm._v("Get Insurance")]), _vm._v(" "), _c('button', {
    staticClass: "btn wn-menu-btn btn-xm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewComponent('set_flie_claim')
      }
    }
  }, [_vm._v("File Claim")]), _vm._v(" "), _c('button', {
    staticClass: "btn wn-menu-btn btn-xm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewComponent('set_flie_complaint')
      }
    }
  }, [_vm._v("File Complaint")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "padding": "1em 3em"
    }
  }, [(_vm.set_component_view.set_flie_complaint) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8 col-md-offset-2"
  }, [_c('h4', [_vm._v("FILE COMPLAINT")]), _vm._v(" "), _c('p', [_vm._v("With InsureMoto scheme we connect you to our multi-insurance partner Cornerstone Insurance to enable you \r\n                                            enjoy the benefits of their advanced insurance system. ")]), _vm._v(" "), _c('cninsurance-file-complaint')], 1)]) : (_vm.set_component_view.set_flie_claim) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-8 col-md-offset-2"
  }, [_c('h4', [_vm._v("FILE CLAIM")]), _vm._v(" "), _c('p', [_vm._v("With InsureMoto scheme we connect you to our multi-insurance partner Cornerstone Insurance to enable you \r\n                                            enjoy the benefits of their advanced insurance system. ")]), _vm._v(" "), _c('cninsurance-file-claim')], 1)]) : _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("Buy or Renew your motor insurance on The Go!")]), _vm._v(" "), _vm._m(1), _vm._v(" "), ((Object.keys(_vm.cninsurance_listing).length !== 0)) ? _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10 col-xs-12 fld"
  }, [_c('div', [_c('cninsurance-post-form', {
    attrs: {
      "cninsurance_listing": _vm.cninsurance_listing,
      "cninsurance": _vm.cninsurance_form_entry
    }
  })], 1)])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn wn-menu-btn btn-xm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewComponent('set_get_insurance')
      }
    }
  }, [_vm._v("Get Insurance")]), _vm._v(" "), _c('button', {
    staticClass: "btn wn-menu-btn btn-xm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewComponent('set_flie_claim')
      }
    }
  }, [_vm._v("File Claim")]), _vm._v(" "), _c('button', {
    staticClass: "btn wn-menu-btn btn-xm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setViewComponent('set_flie_complaint')
      }
    }
  }, [_vm._v("File Complaint")])])])])])], 1)])])]), _vm._v(" "), _c('main-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticStyle: {
      "font-size": "4em",
      "font-weight": "bolder"
    }
  }, [_vm._v("C")]), _vm._v("ityneeds Technologies\r\n                                    Limited is an authorized vendor of Cornerstone Insurance Plc's Third-party Motor Insurance product.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticStyle: {
      "color": "#222223"
    }
  }, [_c('b', [_vm._v("Process your Third-party Motor Insurance")]), _vm._v(" "), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Fill the form below")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7668e990"}!./src/components/CNInsuranceSystem/CNInsuranceListing/template.html
// module id = 305
// module chunks = 0